import React from 'react';
import {
  Box,
  Typography,
  FormGroup,
  FormControlLabel,
  Checkbox,
  TextField,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@mui/material';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const vehicleTypes = [
  { id: 'sedan', label: 'Sedan' },
  { id: 'suv', label: 'SUV' },
  { id: 'van', label: 'Van' },
  { id: 'minibus', label: 'Minibus' },
  { id: 'bus', label: 'Bus' },
  { id: '4x4', label: '4x4 / Off-road' },
];

const VehicleFilterOptions = ({ 
  selectedVehicleTypes = [], 
  minCapacity = '', 
  onVehicleTypeChange, 
  onCapacityChange 
}) => {
  const handleCapacityChange = (e) => {
    const value = e.target.value;
    // Only allow positive numbers
    if (value === '' || (/^\d+$/.test(value) && parseInt(value) >= 0)) {
      onCapacityChange(value);
    }
  };

  return (
    <Accordion defaultExpanded>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="vehicle-filter-content"
        id="vehicle-filter-header"
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <DirectionsCarIcon sx={{ mr: 1 }} />
          <Typography variant="subtitle1">Transportation</Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Typography variant="subtitle2" gutterBottom>
          Vehicle Type
        </Typography>
        <FormGroup>
          {vehicleTypes.map((type) => (
            <FormControlLabel
              key={type.id}
              control={
                <Checkbox
                  checked={selectedVehicleTypes.includes(type.id)}
                  onChange={() => onVehicleTypeChange(type.id)}
                  size="small"
                />
              }
              label={type.label}
            />
          ))}
        </FormGroup>

        <Divider sx={{ my: 2 }} />

        <Typography variant="subtitle2" gutterBottom>
          Minimum Capacity
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          type="number"
          placeholder="Min. passengers"
          value={minCapacity}
          onChange={handleCapacityChange}
          InputProps={{ inputProps: { min: 0 } }}
        />

        <Box sx={{ mt: 2 }}>
          <Typography variant="body2" color="text.secondary">
            Filter tours by the type of vehicle used or minimum passenger capacity.
          </Typography>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default VehicleFilterOptions;
